/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateFeeConfigOptions,
  UpdateFeeConfigStatus200,
  UpdateFeeConfigStatus400,
  UpdateFeeConfigStatus500,
} from '../types/UpdateFeeConfig'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateFeeConfig } from '../clients/updateFeeConfig'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateFeeConfigMutationKey = () =>
  [{ url: '/v1/fees/config/:tenant_id/:tier' }] as const

export function updateFeeConfigMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateFeeConfigMutationKey()
  return mutationOptions<
    UpdateFeeConfigStatus200,
    ResponseErrorConfig<UpdateFeeConfigStatus400 | UpdateFeeConfigStatus500>,
    UpdateFeeConfigOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateFeeConfig({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Admin only. The new rate applies to every period that has not been billed yet, so it is best changed right after a successful daily settlement run.
 * @summary Update the trading fee configuration of a tenant for a tier.
 * {@link /v1/fees/config/:tenant_id/:tier}
 */
export function useUpdateFeeConfig<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateFeeConfigStatus200,
      ResponseErrorConfig<UpdateFeeConfigStatus400 | UpdateFeeConfigStatus500>,
      UpdateFeeConfigOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateFeeConfigMutationKey()

  const baseOptions = updateFeeConfigMutationOptions(config) as UseMutationOptions<
    UpdateFeeConfigStatus200,
    ResponseErrorConfig<UpdateFeeConfigStatus400 | UpdateFeeConfigStatus500>,
    UpdateFeeConfigOptions,
    TContext
  >

  return useMutation<
    UpdateFeeConfigStatus200,
    ResponseErrorConfig<UpdateFeeConfigStatus400 | UpdateFeeConfigStatus500>,
    UpdateFeeConfigOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateFeeConfigStatus200,
    ResponseErrorConfig<UpdateFeeConfigStatus400 | UpdateFeeConfigStatus500>,
    UpdateFeeConfigOptions,
    TContext
  >
}
